/* global module, $, _, debugger, Tracker */
(function () {
    'use strict';

    function hideOnSession ($root) {

        var $elements = {
            toggleTarget: $root,
            toggle: $root.find('.temporarily-hide')
        };

        if ($elements.toggle.length > 0) {
            $elements.toggle.on('click', function () {
                $elements.toggleTarget.hide();
                var date = new Date();
                date.setDate(date.getDate() + 1);
                document.cookie = 'ctcso_close=1;path=/;expires=' + date.toUTCString();
            });
        }
    }

    $(document).on('ready', function () {
        hideOnSession($('.notify-line_close-order'));
    });
})();